var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { IsDateString, IsNumber, IsOptional, IsPositive, IsString } from "class-validator";
import { AbsenceStatus, TimeEntryType } from "../../model";
import { safeAssign } from "./safe-assign";
export class CreateApprovedAbsenceParams {
    constructor(props) {
        this.notes = "";
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsString() // TODO: @IsEnum([TimeEntryType.Vacation, TimeEntryType.Sick, TimeEntryType.ChildSick, TimeEntryType.SickInKUG])
    ,
    __metadata("design:type", String)
], CreateApprovedAbsenceParams.prototype, "type", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsPositive(),
    __metadata("design:type", Number)
], CreateApprovedAbsenceParams.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], CreateApprovedAbsenceParams.prototype, "start", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], CreateApprovedAbsenceParams.prototype, "end", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateApprovedAbsenceParams.prototype, "notes", void 0);
export class AbsenceDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], AbsenceDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbsenceDTO.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], AbsenceDTO.prototype, "created", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], AbsenceDTO.prototype, "updated", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], AbsenceDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbsenceDTO.prototype, "start", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbsenceDTO.prototype, "end", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbsenceDTO.prototype, "notes", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbsenceDTO.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], AbsenceDTO.prototype, "entries", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], AbsenceDTO.prototype, "dayCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], AbsenceDTO.prototype, "request", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], AbsenceDTO.prototype, "response", void 0);
//# sourceMappingURL=absence.dto.js.map